/**
 * SupabaseClient.js
 * 
 * A lightweight fetch-based API client that calls Supabase Edge Functions.
 * The SUPABASE_SERVICE_ROLE_KEY NEVER appears here — it only lives in Edge Function secrets.
 * Only the Edge Function's public URL is referenced here.
 */

const FUNCTION_BASE_URL = process.env.REACT_APP_SUPABASE_FUNCTION_URL;

/**
 * Call a named Supabase Edge Function.
 * @param {string} functionName - e.g. 'contact' or 'download-cv'
 * @param {object} payload - JSON body to send
 * @returns {Promise<{ ok: boolean, status: number, data: object }>}
 */
const callEdgeFunction = async (functionName, payload) => {
  const url = `${FUNCTION_BASE_URL}/${functionName}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let data = {};
  try {
    data = await response.json();
  } catch (_) {
    // Non-JSON response
  }

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
};

const SupabaseClient = {
  /**
   * Submit the contact form message.
   */
  sendContactMessage: (payload) => callEdgeFunction("contact", payload),

  /**
   * Log a resume download (and validate access server-side).
   */
  logResumeDownload: (payload) => callEdgeFunction("download-cv", payload),
};

export default SupabaseClient;
